import { IconBackward } from '@consta/icons/IconBackward'
import { Button } from '@consta/uikit/Button'
import { Text } from '@consta/uikit/Text'
import classnames from 'classnames'
import type { FC, PropsWithChildren, ReactNode } from 'react'

import css from './CardHeader.css'

type FooterBlockHeaderProps = {
  className?: string
  titleClassName?: string
  title: string
  handleBack?: VoidFunction
  leftSlot?: ReactNode
}

export const CardHeader: FC<PropsWithChildren<FooterBlockHeaderProps>> = ({
  children,
  className,
  titleClassName,
  title,
  handleBack,
  leftSlot,
}) => {
  return (
    <header className={classnames(css.header, className)}>
      <span className={css.left}>
        {!!handleBack && (
          <Button
            view="clear"
            size="xs"
            type="reset"
            onlyIcon={true}
            iconLeft={IconBackward}
            onClick={handleBack}
          />
        )}
        <Text
          as="h1"
          view="primary"
          size="s"
          weight="medium"
          className={titleClassName}
          title={title}>
          {title}
        </Text>
        {leftSlot}
      </span>
      {children}
    </header>
  )
}
